module.exports = __webpack_public_path__ + "static/media/b99-facebook.7ed0c58b.png";